import React from "react";
import { useTranslation } from "react-i18next";
import {
  selectableTemporalityTypes,
  TemporalityEnum,
  translateKey,
} from "common/enums/TemporalityEnum";
import { StatusTypeEnum } from "common/enums/StatusTypeEnum";
import {
  MedicationEntryPrescriptionStatusEnum,
  MedicationEntryType,
} from "model/medication-entry.model";
import { Page } from "@cc/react-components";
import ListGroup from "ui/ListGroup";
import { useTrackPageView } from "common/matomo/track-page-view.hook";
import { PV_MEDICATION_STATUS } from "common/matomo/track-page-view.constants";

interface Props extends React.ButtonHTMLAttributes<HTMLElement> {
  selectedTemporality?: TemporalityEnum;
  setSelectedTemporality?: (temporality: TemporalityEnum) => void;
  selectedStatus?: StatusTypeEnum;
  setSelectedStatus?: (status: StatusTypeEnum) => void;
  activeMedicationEntry?: MedicationEntryType;
}

const MedicationStatus = ({
  selectedTemporality,
  setSelectedTemporality,
  selectedStatus,
  setSelectedStatus,
  activeMedicationEntry,
}: Props) => {
  const [t] = useTranslation();

  useTrackPageView(PV_MEDICATION_STATUS);

  const calculateIndex = (): number => {
    if (selectedStatus === StatusTypeEnum.NOT_RELEVANT) {
      return selectableTemporalityTypes().length;
    } else {
      return selectedTemporality || 0;
    }
  };

  const renderTypes = (temporalityEnums: TemporalityEnum[]) => {
    let options = temporalityEnums.map((temporality, index) => (
      <ListGroup.ItemMobile
        key={index}
        className="text-center font-weight-bold p-4"
        active={index === calculateIndex()}
        onClick={() => {
          !!setSelectedStatus && setSelectedStatus(StatusTypeEnum.ACTIVE);
          !!setSelectedTemporality && setSelectedTemporality(index);
        }}
      >
        {t(translateKey(TemporalityEnum[temporality]))}
      </ListGroup.ItemMobile>
    ));

    if (
      activeMedicationEntry &&
      activeMedicationEntry.prescriptionStatus !==
        MedicationEntryPrescriptionStatusEnum.NEW
    ) {
      options.push(
        <ListGroup.ItemMobile
          key={33}
          active={temporalityEnums.length === calculateIndex()}
          onClick={() => {
            !!setSelectedStatus &&
              setSelectedStatus(StatusTypeEnum.NOT_RELEVANT);
          }}
        >
          {t("medicationFlow.passive")}
        </ListGroup.ItemMobile>
      );
    }
    return <ListGroup>{options}</ListGroup>;
  };

  return (
    <Page>
      <Page.Body>
        <Page.Title>{t("medicationFlow.status")}</Page.Title>
        {renderTypes(selectableTemporalityTypes())}
      </Page.Body>
    </Page>
  );
};

export default MedicationStatus;
